import React from "react";
import * as styles from "./popup-sheet-content-empty.module.scss";
import { classArr } from "../../helper/style-helper";

export interface PopupSheetContentEmptyProps {
	style?: React.CSSProperties;
	className?: string;
	children?: React.ReactNode;
}

export default function PopupSheetContentEmpty(
	props: PopupSheetContentEmptyProps,
) {
	return (
		<div
			style={props.style}
			className={classArr(styles.container, props.className)}
		>
			{props.children}
		</div>
	);
}
